(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[457],{

/***/ "6Pbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhotoAlbum", function() { return PhotoAlbum; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var PhotoAlbum = function PhotoAlbum(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M435.2 0H64.8C29.1 0 0 29.1 0 64.8v370.4C0 470.9 29.1 500 64.8 500h370.4c35.7 0 64.8-29.1 64.8-64.8V64.8C500 29.1 470.9 0 435.2 0zm46.3 435.2c0 25.5-20.8 46.3-46.3 46.3H64.8c-25.5 0-46.3-20.8-46.3-46.3V64.8c0-25.5 20.8-46.3 46.3-46.3h370.4c25.5 0 46.3 20.8 46.3 46.3v370.4z"
  }), __jsx("path", {
    d: "M417.2 56H83.8C68.4 56 56 68.4 56 83.8v333.4c0 15.3 12.4 27.8 27.8 27.8h333.4c15.3 0 27.8-12.4 27.8-27.8V83.8c0-15.4-12.4-27.8-27.8-27.8zm8.8 360.7c0 5.1-4.2 9.3-9.3 9.3H83.3c-5.1 0-9.3-4.2-9.3-9.3v-87.9l9.4 7.4 81.4-103.1 77.6 101.1 57.2-46.4 70.3 83.1 34.7-46.9 13 13.1 8.5-8.4v88zm0-104.6l-24.1-24.4-33.4 45.1-65.9-78-56.3 45.7-81.3-106-91 115.3V83.3c0-5.1 4.2-9.3 9.3-9.3h333.3c5.1 0 9.3 4.2 9.3 9.3v228.8z"
  }), __jsx("path", {
    d: "M277.8 117.8c-27 0-48.9 21.9-48.9 48.9s21.9 48.9 48.9 48.9 48.9-21.9 48.9-48.9-22-48.9-48.9-48.9zm0 74.1c-13.9 0-25.2-11.3-25.2-25.2 0-13.9 11.3-25.2 25.2-25.2 13.9 0 25.2 11.3 25.2 25.2 0 13.9-11.3 25.2-25.2 25.2z"
  }));
};

/***/ })

}]);